import React from 'react';
import { Card, Tab } from 'react-bootstrap';

import { useTranslation } from '../../../common/hooks/useTranslation';
import { TabsHistory } from '../../../app/components/TabsHistory';
import { ClientContacts } from '../../components/Clients/ClientContacts';
import { ClientWithoutContact } from '../../components/Clients/ClientWithoutContact';

export const SurveyClientsListView: React.FC = () => {
  const { t, tk } = useTranslation('clientLng');

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">
          {t(tk.client.surveyClientsList)}
        </Card.Title>
        <TabsHistory activeKey="contacts" id="survey-clients-tabs">
          <Tab
            eventKey="contacts"
            title={t(tk.client.contactsTab)}
            className="m-3"
          >
            <ClientContacts />
          </Tab>
          <Tab
            eventKey="withoutContact"
            title={t(tk.client.withoutContactTab)}
            className="m-3"
          >
            <ClientWithoutContact />
          </Tab>
        </TabsHistory>
      </Card.Body>
    </Card>
  );
};
